module.exports = __webpack_public_path__ + "step-2-desktop.ca0a6eac39ea1db230f3.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/payment-catalog/step-2-desktop.png
// module id = ../../../../../src/assets/payment-catalog/step-2-desktop.png
// module chunks = styles